import React from 'react'

import {createSvgIcon} from './utils'

export default createSvgIcon(
  <path
    clipRule="evenodd"
    d="M17.5561 3.70698C17.5892 3.67392 17.624 3.64367 17.6602 3.61621C18.1986 3.9206 18.7669 4.30792 19.2294 4.77048C19.7271 5.26811 20.1376 5.88801 20.4515 6.46156C20.4306 6.487 20.4083 6.51165 20.3846 6.5354L17.5164 9.40356C17.1793 8.85356 16.7561 8.27028 16.2427 7.75688C15.7645 7.27863 15.2256 6.87869 14.7095 6.55366L17.5561 3.70698ZM13.251 8.01213L4.03272 17.2304L3.414 20.6775L6.86114 20.0588L16.0531 10.8668C15.7389 10.292 15.3275 9.67007 14.8285 9.17109C14.3636 8.70614 13.7919 8.31722 13.251 8.01213Z"
    fillRule="evenodd"
  />,
  'Pen',
)
